import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { ICommunityPassports } from '../../models/passport.models';
import { Profile } from '../../models/profile.model';
import { PassportService } from '../../services/passport.service';

@Component({
  selector: 'app-community-passports',
  templateUrl: './community-passports.component.html',
  styleUrls: ['./community-passports.component.css']
})
export class CommunityPassportsComponent implements OnInit {

  public communityPassports: {[section: string]: Profile[]} = {};
  public defaultImageURL = environment.apiURL + 'images/MyProfile/user-icon-1 (4).png';
  public noMatchFound = false;
  public loaderState: Record<string, 'loading' | 'error' | 'hide'> = {
    RECOMMENDED: 'loading',
    NEW: 'loading',
    TRENDING: 'loading',
    DISCOVER: 'loading'
  };

  constructor(private passportService: PassportService, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.spinner.show();

    this.getRecommendedProfiles();

    this.getTrendingProfiles();

    this.getNewProfiles();

    this.getDiscoverProfiles();
  }

  private getDiscoverProfiles(): void {
    this.passportService.getCommunityPassports('DISCOVER').then(response => {
      this.sortProfiles(response);
      this.loaderState.DISCOVER = 'hide';
    }).catch(e => {
      console.error(e);
      this.spinner.hide();
      this.loaderState.DISCOVER = 'error';
    });
  }

  private getNewProfiles(): void {
    this.passportService.getCommunityPassports('NEW').then(response => {
      this.sortProfiles(response);
      this.loaderState.NEW = 'hide';
    }).catch(e => {
      console.error(e);
      this.spinner.hide();
      this.loaderState.NEW = 'error';
    });
  }

  private sortProfiles(response: ICommunityPassports): void {
    const sortedProfiles = this.sortByProfilePic(response.passportProfiles);
    this.communityPassports[response.section] = sortedProfiles;
    this.spinner.hide();
  }

  private getTrendingProfiles(): void {
    this.passportService.getCommunityPassports('TRENDING').then(response => {
      this.sortProfiles(response);
      this.loaderState.TRENDING = 'hide';
    }).catch(e => {
      console.error(e);
      this.spinner.hide();
      this.loaderState.TRENDING = 'error';
    });
  }

  private getRecommendedProfiles(): void {
    this.passportService.getCommunityPassports('RECOMMENDED').then(response => {
      this.sortProfiles(response);
      this.loaderState.RECOMMENDED = 'hide';
    }).catch(e => {
      console.error(e);
      this.spinner.hide();
      this.loaderState.RECOMMENDED = 'error';
    });
  }

  getTrendingProfileBorder(index: number): string {
    if (index % 3 === 0) {
      return 'profile-thumbnail-border-yellow';
    } else if (index % 3 === 1) {
      return 'profile-thumbnail-border-red';
    } else {
      return 'profile-thumbnail-border-white';
    }
  }

  getRecommendedProfileBorder(index: number): string {
    if (index % 3 === 0) {
      return 'profile-thumbnail-border-white';
    } else if (index % 3 === 1) {
      return 'profile-thumbnail-border-red';
    } else {
      return 'profile-thumbnail-border-yellow';
    }
  }

  getNewProfileBorder(index: number): string {
    if (index % 3 === 0) {
      return 'profile-thumbnail-border-red';
    } else if (index % 3 === 1) {
      return 'profile-thumbnail-border-white';
    } else {
      return 'profile-thumbnail-border-yellow';
    }
  }

  getDiscoverProfileBorder(index: number): string {
    if (index % 3 === 0) {
      return 'profile-thumbnail-border-yellow';
    } else if (index % 3 === 1) {
      return 'profile-thumbnail-border-white';
    } else {
      return 'profile-thumbnail-border-red';
    }
  }

  private sortByProfilePic(passportProfiles: Profile[]): Profile[] {
    const profiles = passportProfiles.filter(p => p.userImageUrl);
    passportProfiles.filter(p => !p.userImageUrl).forEach(p => profiles.push(p));
    return profiles;
  }

  getSearchResult(term: string): void {
    if (term && term.length > 3) {
      this.executeProfileSearch(term);
    }
  }

  private executeProfileSearch(term: string): void {
    this.spinner.show();
    this.passportService.searchPassports(term).then(response => {
      this.spinner.hide();
      this.communityPassports.DISCOVER = response;
      this.noMatchFound = !(response && response.length);
    }).catch(err => {
      this.spinner.hide();
      console.error(err);
    });
  }

  getSearchResultEnter(event: any, term: string): void {
    if (event.key === 'Enter' && term && term.length) {
      this.executeProfileSearch(term);
    } else if (event.key === 'Enter' && !term) {
      this.getDiscoverProfiles();
      this.noMatchFound = false;
    }
  }

  resetSearchOnBlur(term: string): void {
    if (!term) {
      this.getDiscoverProfiles();
      this.noMatchFound = false;
    }
  }
}
